import './assets/main.scss'

import store from '@/store'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import router from './router'

import '@/plugins/bootstrap-vue'
import { i18n } from '@/plugins/i18n'
import addMaskaDirective from '@/plugins/maska'
import initSentry from '@/plugins/sentry'
import '@/plugins/smoothscroll'
import '@/plugins/vee-validate'
import initVueFlatPickr from '@/plugins/vue-flatpickr-component'

import initOrphansDirective from '@/directives/orphans'

const app = createApp(App)

initSentry(app, router)

app.use(createPinia())
app.use(store)
app.use(router)
app.use(i18n)

addMaskaDirective(app)
initVueFlatPickr(app)

initOrphansDirective(app)

app.mount('#app')
